<div class="bg-base-100 shadow-md h-full p-5 rounded-xl flex flex-col items-center justify-between gap-5 text-center">
    <div class="flex flex-col items-center gap-3">
        <h4 class="mb-0">{{ cardTitle }}</h4>
        <span *ngIf="cardSubtitle">{{ cardSubtitle }}</span>
    </div>
    <button class="btn btn-outline border-[3px] rounded-full" [ngClass]="{ loading: loading }" [disabled]="loading" (click)="onClick()">
        {{ buttonText }}
    </button>
</div>
